import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Activities from "./pages/Activities";
import GolfTournament from "./pages/GolfTournament";
import FishingTournament from "./pages/FishingTournament";
import VeteransPark from "./pages/VeteransPark";
import Membership from "./pages/Membership";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/golf-tournament" element={<GolfTournament />} />
          <Route path="/fishing-tournament" element={<FishingTournament />} />
          <Route path="/veterans-park" element={<VeteransPark />} />
          <Route path="/membership" element={<Membership />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
